import React from "react";
import s1 from '../assets/s1.png';
import s2 from '../assets/s2.png';

const EventInfoSection = () => (
  <section className="py-16 bg-[#fdf7f7]">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-4xl font-extrabold text-center mb-10">
        Smash Into <span className="text-red-600">ShuttleClash 2025</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="bg-white rounded-2xl shadow-lg p-0 flex flex-col items-center overflow-hidden">
          <div className="relative w-full flex flex-col items-center">
            <img src={s1} alt="Event Date" className="w-full h-56 object-cover" />
            <span className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-red-600 text-white text-base md:text-lg font-semibold rounded-full px-4 md:px-8 py-2 md:py-3 shadow whitespace-nowrap">August 15 & 16, 2025</span>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-0 flex flex-col items-center overflow-hidden">
          <div className="relative w-full flex flex-col items-center">
            <img src={s2}  alt="Venue" className="w-full h-56 object-cover" />
            <span className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-red-600 text-white text-base md:text-lg font-semibold rounded-full px-4 md:px-8 py-2 md:py-3 shadow whitespace-nowrap">LOG IN Sports Academy</span>
            <span className="absolute bottom-2 left-1/2 -translate-x-1/2 text-xs md:text-sm text-white bg-black/60 px-2 md:px-4 py-1 rounded-full break-words max-w-xs md:max-w-md text-center ">2/295 A, Sankari Main Rd, Kathayammal Nagar, Nethimedu, Salem - 636002</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EventInfoSection; 